// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import OtpOverview from './OtpOverview';
// Renamed variants
import OtpClassicMinimal from './OtpClassicMinimal';
import OtpHeroImage from './OtpHeroImage';
import OtpDarkMode from './OtpDarkMode';
// Existing variants
import OtpSplit from './OtpSplit';
import OtpGradient from './OtpGradient';
import OtpModern from './OtpModern';
import OtpAnimated from './OtpAnimated';
import OtpIllustrated from './OtpIllustrated';
import OtpParallax from './OtpParallax';
import OtpMinimal3D from './OtpMinimal3D';
import OtpSplitScreen from './OtpSplitScreen';
// New variants
import OtpCenteredCard from './OtpCenteredCard';
import OtpGlassmorphism from './OtpGlassmorphism';
import OtpMobileAppStyle from './OtpMobileAppStyle';
import OtpSocialLogin from './OtpSocialLogin';
import OtpSidebar from './OtpSidebar';
import OtpCarouselOnboarding from './OtpCarouselOnboarding';

export default function OtpRoutes() {
  return (
    <Routes>
      <Route index element={<OtpOverview />} />
      {/* Renamed routes */}
      <Route path="classic-minimal" element={<OtpClassicMinimal />} />
      <Route path="hero-image" element={<OtpHeroImage />} />
      <Route path="dark-mode" element={<OtpDarkMode />} />
      {/* Existing routes */}
      <Route path="split" element={<OtpSplit />} />
      <Route path="gradient" element={<OtpGradient />} />
      <Route path="modern" element={<OtpModern />} />
      <Route path="animated" element={<OtpAnimated />} />
      <Route path="illustrated" element={<OtpIllustrated />} />
      <Route path="parallax" element={<OtpParallax />} />
      <Route path="minimal3d" element={<OtpMinimal3D />} />
      <Route path="splitscreen" element={<OtpSplitScreen />} />
      {/* New routes */}
      <Route path="centered-card" element={<OtpCenteredCard />} />
      <Route path="glassmorphism" element={<OtpGlassmorphism />} />
      <Route path="mobile-app-style" element={<OtpMobileAppStyle />} />
      <Route path="social-login" element={<OtpSocialLogin />} />
      <Route path="sidebar" element={<OtpSidebar />} />
      <Route path="carousel-onboarding" element={<OtpCarouselOnboarding />} />
    </Routes>
  );
}
